import React, { useState } from "react";

// APP COMPONENTS
import { orderStatusNumberFrame } from "../../common/frames";

// MATERIAL UI COMPONENTS
import {
  AutocompleteStyledPaper,
  AutocompleteStyledPopper,
  StyledAutocomplete,
} from "../styled/inputs/autocomplete";
import { StyledTextField } from "../styled/inputs/textInput";

const OrderStatusFilter = ({ selectedValue, onFilterChange }) => {
  const [status, setStatus] = useState(orderStatusNumberFrame);

  return (
    <StyledAutocomplete
      disablePortal={false}
      id="order-status-values"
      options={status}
      getOptionLabel={(option) => option.label}
      groupBy={(option) => option.firstLetter}
      renderInput={(params) => (
        <StyledTextField
          {...params}
          label="Status do Pedido"
          variant="outlined"
          InputProps={{
            ...params.InputProps,
          }}
        />
      )}
      PopperComponent={(props) => <AutocompleteStyledPopper {...props} />}
      PaperComponent={(props) => <AutocompleteStyledPaper {...props} />}
      onChange={(event, values) => {
        onFilterChange(values);
      }}
      sx={{ mb: 1 }}
    />
  );
};

OrderStatusFilter.displayName = "Status do Pedido";

export default OrderStatusFilter;
